<div class="contact-btn">
  <ssc-contact-btn [showContactButton]="showContactButton"></ssc-contact-btn>
</div>

<visana-lib-footer [links]="footerLinks" [contentProjectionRight]="true">
  <div contentRight>
    <ssc-language-selector [displayInHeader]="false" class="language-selector"></ssc-language-selector>
  </div>
</visana-lib-footer>
